import styled from 'styled-components';

const ListingRootElement = styled.div`
    background: #f9f9f9;
    padding: 48px 0;
    @media (max-width: 767px) {
        padding: 0;
    }
    .grid-col {
        grid-gap: 24px;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        display: grid;
        @media (max-width: 1040px) {
            grid-template-columns: 1fr 1fr 1fr;
            @media (max-width: 991px) {
                grid-template-columns: 1fr 1fr;
                @media (max-width: 767px) {
                    grid-template-columns: 1fr;
                }
            }
        }
    }
    .load-more {
        margin-top: 48px;
        padding-top: 32px;
        @media (max-width: 767px) {
            padding: 32px 0px !important;
        }
        width: 100%;
        border-top: #e5e5e5 solid 1px;
    }
    .partner-heading{
        margin-bottom:24px;
        display:block;
        @media (max-width: 767px) {
            margin-bottom:18px;
        }
    }
`;
export default ListingRootElement;
